<template>
  <div class="historyList">
    <h2>Verlauf</h2>
    <div v-for="(post, index) in posts" @click="setHistory(post)"  v-bind:key="post['.key']">
      <h4 v-if="index == 0 || !equalsBefore(post.created, posts[index - 1].created)">{{post.created|defaultDay}}, {{post.created|defaultDate}}</h4>
      <div v-bind:class="{ active: current(post) }">
        <span style="opacity: 0.6;">{{post.created|defaultTime}}: </span>
        <b>
          {{post.title}}
        </b>
        <span style="opacity: 0.6;"> hinzugefügt</span>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'HistoryList',
  props: ['posts'],
  data () {
    return {
      currentHistory: false
    }
  },
  mounted () {
    this.setHistory(this.posts[0])
  },
  methods: {
    setHistory (post) {
      this.currentHistory = post
      this.$emit('setHistory', post)
    },
    current (post) {
      if (post === this.currentHistory) {
        return true
      } else {
        return false
      }
    },
    equalsBefore (current, before) {
      var SpecialTo = moment(before)
      if (moment(current).diff(SpecialTo, 'days') === 0) {
        return true
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .historyList {

    div > div {

      border-bottom: 1px solid #efefef;
      padding: 10px 0;
      cursor: pointer;
      user-select: none;
      color: $color-action;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &.active {
        background: rgba($color-action, 0.1);
        padding: 10px;
        margin-left: -10px;
        margin-right: -10px;;
      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/HistoryList.vue